import { TreeLinesProps } from "./types";
import { TREE_CONSTANTS } from "./utils";

const TreeLines: React.FC<TreeLinesProps> = ({ depth }) => {
  if (depth === 0) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute inset-y-0 left-0">
      {Array.from({ length: depth }, (_, index) => (
        <div
          key={index}
          className="absolute inset-y-0 border-l border-gray-200"
          style={{
            left: `${12 + index * TREE_CONSTANTS.INDENT_WIDTH + TREE_CONSTANTS.LINE_OFFSET}px`,
          }}
        />
      ))}
    </div>
  );
};

export default TreeLines;
